import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${solid ? 'border-b border-background-200 bg-background-50' : 'border-b border-transparent bg-transparent'}`}
    >
      <nav className="flex h-16 w-full items-center justify-between px-5 md:h-20 md:px-10 xl:px-16" aria-label="Primary">
        <Link to="/" className="flex cursor-pointer items-baseline gap-3" aria-label="AVENOR home">
          <span className="font-poster text-[28px] font-extrabold leading-none tracking-[0.04em] text-primary-500 md:text-[32px]">AVENOR</span>
        </Link>

        <ul className="hidden items-center gap-10 md:flex">
          {navLinks.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                className={({ isActive }) => `cursor-pointer whitespace-nowrap text-sm tracking-[0.02em] transition-colors hover:text-primary-500 ${isActive ? 'text-primary-500' : 'text-foreground-950'}`}
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <Link
          to="/contact"
          className="hidden cursor-pointer items-center gap-2 whitespace-nowrap border border-foreground-950 px-4 py-2 font-label text-[11px] uppercase tracking-[0.14em] text-foreground-950 transition-colors hover:border-primary-500 hover:bg-primary-500 hover:text-background-50 md:inline-flex"
        >
          Start a conversation
        </Link>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-11 w-11 cursor-pointer items-center justify-center whitespace-nowrap text-foreground-950 md:hidden"
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
        </button>
      </nav>

      {open && (
        <div className="h-[calc(100svh-64px)] border-t border-background-200 bg-background-50 px-5 pt-8 md:hidden">
          <ul className="flex flex-col">
            {navLinks.map((l, i) => (
              <li key={l.to} className="border-b border-background-200">
                <Link to={l.to} className="flex cursor-pointer items-baseline justify-between py-5">
                  <span className="text-3xl font-light text-foreground-950">{l.label}</span>
                  <span className="font-label text-[11px] text-primary-500">0{i + 1}</span>
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-10 font-label text-[11px] uppercase tracking-[0.14em] text-foreground-600">Accounting &amp; Advisory</p>
        </div>
      )}
    </header>
  );
}